import { FC } from 'react'
import { TestCam } from 'components/features/coaching/advisorVideoCall/TestCam/TestCam'


export const TestMedia: FC = () => {

  return (
    <>
      <TestCam />
      <h4>Take this time to turn on your <br /> microphone and camera below.</h4>
    </>
  )
}
